"use client"

import { pickBannerImageFormat } from "@/(admin)/modules/ui-builder/config/lib/post-helpers"
import BannerWithTracking from "@/components/BannerWithTracking"
import { toImageSrc } from "@/lib/utils"
import { BannerData } from "@/types/types"
import Image from "next/image"

type BannerCardProps = {
  banner?: BannerData
  isMobile: boolean
  className?: string
}

export default function BannerCard({ banner, isMobile, className }: BannerCardProps) {
  if (!banner) return null

  const { attributes } = banner

  // Extract tracking config from common field
  const trackingConfig = attributes.common ? {
    clickUrl: attributes.common.clickUrl,
    impressionHtml: attributes.common.impressionHtml,
    vendorScriptSrc: attributes.common.vendorScriptSrc,
    vendorNoscriptHtml: attributes.common.vendorNoscriptHtml,
  } : undefined

  return (
    <BannerWithTracking
      bannerId={`banner-card-${banner.id}`}
      bannerUrl={attributes.url}
      trackingConfig={trackingConfig}
      className={`image-hover group ${className || ""}`}
    >
      <Image
        src={toImageSrc(pickBannerImageFormat(banner, isMobile, "medium") ?? undefined)}
        alt={attributes.name}
        width={300}
        height={300}
        className="w-full h-auto object-cover"
      />
    </BannerWithTracking>
  )
}
